<template>
  <div class="tablist">
    <el-tabs
      v-model="editableTabsValue"
      class="myTopTab"
      type="card"
      closable
      @tab-click="clickTab"
      @tab-remove="removeTab"
    >
      <el-tab-pane
        v-for="(item, idx) in editableTabs"
        :key="idx"
        :label="item.title"
        :name="item.name"
      >
        <span slot="label" class="active">
          {{ $i18n.locale === "zh-CN" ? item.title : item.enTitle }}
        </span>
      </el-tab-pane>
    </el-tabs>
    <slot />
  </div>
</template>

<script>
// import menu from './routerList';
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "Tablist",
  data() {
    return {
      editableTabsValue: "1",
      navTab: "",
      editableTabs: [
        {
          title: "账户管理",
          enTitle: "Account Admin",
          name: "1",
          routerName: "accountAdmin",
        },
      ],
      tabIndex: 1,
      userMenu: JSON.parse(sessionStorage.getItem("tabrouterList")) || [],
      tabNode: null,
    };
  },
  computed: {
    ...mapGetters(["$user"]),
  },
  watch: {
    $route: {
      handler(to, from) {
        this.editableTabsValue = this.$user.tabActive;
        this.addTab(to);
      },
    },
    editableTabs: {
      handler(newV) {
        if (newV.length === 1) {
          this.tabNode.style.top = "-5px";
        } else {
          this.tabNode.style.top = "5px";
        }
      },
    },
  },
  mounted() {
    this.tabNode = document.documentElement.querySelector(".el-tabs__nav");
    this.addTab(this.$route);
  },
  created() {
    if (this.$user.tabList.length > 0) {
      this.editableTabs = this.$user.tabList;
    }
    this.editableTabsValue = this.$user.tabActive;
  },
  methods: {
    clickTab(val) {
      if (val !== this.navTab) {
        this.navTab = val;
        this.userMenu.forEach((item) => {
          if (item.label === val.label) {
            this.$router.push({ name: item.routerName });
          }
        });
        this.vuex_tab_active(val);
      }
    },
    addTab(val) {
      this.userMenu.forEach((item) => {
        if (item.routerName === val.name) {
          this.toreAdd(item);
        }
      });
    },
    toreAdd(val) {
      let _index = 0;
      this.editableTabs.forEach((item) => {
        if (item.title === val.label) {
          _index = 1;
          this.editableTabsValue = item.name;
        }
      });
      if (_index === 0) {
        let idx = this.editableTabs.length - 1;
        this.editableTabs.push({
          title: val.label,
          enTitle: val.enLabel,
          routerName: val.routerName,
          name: parseFloat(this.editableTabs[idx].name) + 1 + "",
        });
        var _this = this;
        setTimeout(() => {
          _this.editableTabsValue =
            parseFloat(this.editableTabs[idx].name) + 1 + "";
          _this.vuex_tab_active(_this.editableTabsValue);
          _this.vuex_tab_list(_this.editableTabs);
        }, 100);
      } else {
        this.vuex_tab_active(this.editableTabsValue);
      }
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      let isSaveCard = false;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            if (this.removeList.indexOf(tab.routerName) !== -1) {
              isSaveCard = true;
            }
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      this.vuex_tab_active(this.editableTabsValue);
      this.vuex_tab_list(this.editableTabs);
      if (isSaveCard) {
        // bus.$emit('resetForms');
      } else {
        this.editableTabs.forEach((item) => {
          if (item.name === activeName) {
            this.$router.push({ name: item.routerName });
          }
        });
      }
    },
    // 获取vuex中的提交方法
    ...mapMutations({
      vuex_tab_list: "set_tab_list",
      vuex_tab_active: "set_tab_active",
    }),
  },
};
</script>

<style scoped lang="less">
@import url("../style/tabStyle.less");
</style>



// WEBPACK FOOTER //
// src/components/eleTab.vue